import cryptico from 'cryptico';
import {decrypt, encrypt, miniEncrypt, miniDecrypt} from './miniEncrypt.js';
import ethereum from 'decentralized/ethereum.js';
import {soundShuffle, undoShuffle} from './soundShuffle.js';
import {splitIntoBytes32} from './splitIntoBytes32.js';
import aesjs from 'aes-js';

const algo = {
    name: "AES-CTR",
    //Don't re-use counters!
    //Always use a new counter every time your encrypt!
    counter: new aesjs.Counter(5)._counter,
    length: 32, //can be 1-128
};

class ContentKey {
    constructor(contentKey=cryptico.generateAESKey()) {
        if (typeof contentKey === "string") {
            this.contentKey = aesjs.utils.hex.toBytes(contentKey);
        } else {
            this.contentKey = contentKey;
        }
        this.publicKey = undefined;
    }

    // encrypts the content key using the public key passed
    encryptKey(publicKey) {
        this.publicKey = publicKey;
        let contentKeyHex = aesjs.utils.hex.fromBytes(this.contentKey);
        let encryptedContentKey64 = cryptico.encrypt(contentKeyHex, publicKey).cipher;
        let encryptedContentKey = ethereum.web3.utils.toHex(encryptedContentKey64);
        this.encryptedContentKey = encryptedContentKey;
        this.eck = encryptedContentKey64;
    }

    // converts the encrypted content key into a format used in the
    // ethereum smart contract (i.e. bytes32[9])
    convertForEthereum() {
        return splitIntoBytes32(this.encryptedContentKey);
    }

    // encrypts the given content, which is either a raw string or bytes
    async encryptContent(contentToEncrypt, isBytes=false) {
        if (contentToEncrypt === undefined) {
            return '';
        }

        let buffer = new Uint8Array(this.contentKey).buffer;

        console.log('encrypt content= ', contentToEncrypt);
        var contentBytes = isBytes ? contentToEncrypt: aesjs.utils.utf8.toBytes(contentToEncrypt);
        let shuffled = isBytes ? soundShuffle(contentBytes, new Uint8Array(this.contentKey)) :
            contentBytes;
        if (isBytes) {
            let encryptedBytes = await miniEncrypt(shuffled, buffer);
            return encryptedBytes;
        } else {
            let encryptedBytes = await encrypt(contentBytes, this.contentKey);
            var encryptedHex = aesjs.utils.hex.fromBytes([... new Uint8Array(encryptedBytes)]);
            return encryptedHex;
        }
    }

    decryptContent(encryptedContent, isBytes=false) {
        if (!isBytes) {
            return new Promise(async (resolve, reject) => {
                try {
                var encryptedBytes = typeof encryptedContent === "string" ?
                    aesjs.utils.hex.toBytes(encryptedContent) :
                    encryptedContent;
                let decryptedBytes = await decrypt(new Uint8Array(encryptedBytes), this.contentKey);
                let fromBytes = aesjs.utils.utf8.fromBytes([... new Uint8Array(decryptedBytes)]);
                resolve(fromBytes);
                } catch (e) {
                    console.log('error=', e);
                    resolve('');
                }
            });;
        }
        return new Promise(async (resolve, reject) => {
            // if there are a bunch of zeroes at the end skip them
            let decryptedBytes = await miniDecrypt(encryptedContent, this.contentKey);
            decryptedBytes = undoShuffle(decryptedBytes, new Uint8Array(this.contentKey));
            resolve(decryptedBytes);
        });
    }

    getPublicKeyAsBytes32() {
        let masterPublicKey = ethereum.web3.utils.toHex(this.publicKey);
        return splitIntoBytes32(
            masterPublicKey);
    }
}

export default ContentKey;
